import { render, staticRenderFns } from "./SetPrice.vue?vue&type=template&id=078f263c&"
import script from "./SetPrice.vue?vue&type=script&lang=ts&"
export * from "./SetPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports